/**
 * Checks if a user has any of the required permissions
 * @param {Array} permissions - Array of user permissions, each with a PermissionId property
 * @param {Array} requiredPermissionIds - Array of permission IDs to check against
 * @returns {boolean} - True if any of the required permissions are found, false otherwise
 */
export const checkAllowedAccess = (
  permissions = [],
  requiredPermissionIds = [],
) => {
  if (!requiredPermissionIds || requiredPermissionIds.length === 0) {
    return true;
  }

  if (!permissions || permissions.length === 0) {
    return false;
  }

  return permissions.some((permission) =>
    requiredPermissionIds.some(
      (permissionId) => permissionId === permission.Id,
    ),
  );
};
